import React, {useEffect, useState} from 'react';
import { useSelector , useDispatch} from 'react-redux';
import {
  Grid, Button, Stack, Box, Tooltip, Collapse,  Paper, Link, Fab,
} from '@mui/material';


import {usePlayContext} from '../utils/PlayContext';
import {useViewContext} from '../utils/ViewContext';
import {useAppAuthContext} from '../utils/AppAuthContext';


import { visitorsSyncLoaded,
  selectVisitorIds,
  selectVisitorById,
  refreshlVisitors,
  selectAllVisitors, selectVisitorByFilter,
  selectVisitorByEmail, fetchAllVisitors } from '../store/visitorSlice';



import ClearIcon from '@mui/icons-material/Clear';


import TextField from '@mui/material/TextField';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
//import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';

import AddIcon from '@mui/icons-material/Add';

import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Tty';
import CompanyIcon from '@mui/icons-material/Business';

//import  from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';


import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import ResetIcon from '@mui/icons-material/HighlightOff';
import RefreshIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';

import CreateIcon from '@mui/icons-material/Add';



import { useNavigate } from 'react-router-dom';


const VisitorItem = ({id, index})=>
{
    const navigate = useNavigate()

    //const {userInfo}=useAppAuthContext()

    const visitor = useSelector(selectVisitorById(id))

    const inviteVisitor = (id)=>{
      navigate("/invite_visitor/"+id)
    }
 
    const gotoDetails = (id)=>{
      navigate("/visitor/view/"+id)
    }
    //bgcolor:`${(index%2)===0 ? "#EAF2F8":"#E9F7EF"}`
    return(
    <Card sx={{width:'100%', border:1, pt:1, }}>
       
      <CardContent sx={{py:0, my:0 }}>
      <Grid  container 
                          columns={18}
                          sx={{py:0, 
                          mb:{xs:0, md:0},
                          px:{xs:1, md:0},
                          border:{xs:0,md:0},
                          borderColor:'#aaaaaa',
                          borderRadius:1,
                          }}>

                  {
                  <Grid item xs={18} md={3} 
                      sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        
                        <Tooltip title="Name">                   
                        <Link onClick={()=>gotoDetails(id)}>       
                          <Typography  variant="body2"  >
                          <PersonIcon size='small' color="primary"  sx={{mr:1, }}/>
                            {visitor.name}
                          </Typography>
                        </Link>
                        </Tooltip>
                  </Grid>
                 }
                  <Grid item xs={18} md={3} 
                              sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                          
                          <Tooltip title="Phone Number">
                              <Typography  variant="body2"  >
                            <PhoneIcon size='small' color="primary"  sx={{mr:1, }}/>
                            {visitor.phoneDisplay}
                          </Typography>
                          
                          </Tooltip>
                  </Grid>

                  <Grid item xs={18} md={5} 
                      sx={{mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        <Tooltip title="Email">
                            <Typography  variant="body2"  >
                            <EmailIcon size='small' color="primary"  sx={{mr:1, }}/>
                              {visitor.email}
                            </Typography>
                        </Tooltip>
                  </Grid>
                  <Grid item xs={18} md={6} 
                      sx={{ mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        <Tooltip title="Organization">
                            <Typography  variant="body2"  >
                            <CompanyIcon size='small' color="primary"  sx={{mr:1, }}/>
                              {visitor.company}
                            </Typography>
                        </Tooltip>
                    </Grid>
                    { 
                    
                    /*** 
                    userInfo.roles==='ADMIN' &&
                    <Grid item xs={18} md={3} 
                      sx={{ mx:1, borderBottom: 1, borderBottomColor:'#cccccc'}}>
                        <Tooltip title="Host">
                            <Typography  variant="body2"  >
                            <HostIcon size='small' color="primary"  sx={{mr:1, }}/>
                              {visitor.host}
                            </Typography>
                        </Tooltip>
                    </Grid>
                    */
                    }   
                </Grid>
                </CardContent>
        
                <CardActions>
                  <Box sx={{mx:1, display:'flex', justifyContent: 'space-around', width:'100%'}}>
                   <Button variant="outlined"size="small" sx={{mx:1}}
                      onClick={()=>gotoDetails(id)}
                   >
                    {/***<FavoriteIcon size='small' /> ***/}
                    View
                  </Button> 

                  <Button variant="outlined"size="small" 
					sx={{mx:1}}
                    color='success'
					onClick={()=>navigate("/visitor/edit/"+id)}
                   >Edit</Button>

                   <Button variant="outlined"size="small" 
					sx={{mx:1}}
                    color='success'
					onClick={()=>inviteVisitor(id)}
                   >
                    {/*<ShareIcon size='small'/>*/}
                    
                    Invite</Button>
                  </Box>
                </CardActions>
        </Card>
    );

}


const VisitorFilterPane = ()=>{
      const navigate=useNavigate()
      const dispatch = useDispatch()

      const {
        setOp,
        status, setStatus, appTitle, setAppTitle, 
        setErrorMessage, errorTitle, setErrorTitle,
      }=usePlayContext()

      const {
        viewFilter, setViewFilter
      }=useViewContext()

  const [phone, setPhone] = React.useState(viewFilter?.phone ? viewFilter?.phone:'')
  const [email, setEmail] = React.useState(viewFilter?.email ? viewFilter?.email:'')
  const [name, setName] = React.useState(viewFilter?.name ?viewFilter?.name:'' );
  const [company, setCompany] = React.useState(viewFilter?.company?viewFilter?.company:'');
  const [expanded, setExpanded] = React.useState(!false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const doRefresh = async ()=>{
    setStatus('processing')
    handleReset()
    try
    {
        let respAllVisitors = await dispatch(refreshlVisitors(0)).unwrap();

        setStatus('idle')
    }
    catch (ex)
    {
      setStatus('error')
      setErrorMessage("Cannot retrieve Visitor info")
    } 
  }

  const handleReset=()=>{
    setName('')
    setCompany('')
    setPhone('')
    setEmail('')
    setViewFilter({
        name:'',
        email:'',
        phone:'',
        company:'',

    })
    }

    const doSerachVisitor= ()=>
    {
        //alert("name="+name)

        const __dd=(x)=>
        {
            if (x) return x.trim().toLowerCase();
            return x;
        }
        //alert("name2="+__dd(name))

        let newVal = 
        {
          name: __dd(name),
          email: __dd(email), 
          phone: __dd(phone), 
          company: __dd(company),
        }
        setViewFilter(newVal)

    }
    return (   <Card  sx={{m:1, p:0, border:1, }}>
      <CardActions  disableSpacing   sx={{p:0,my:0, mx:1}}> 
        <Tooltip title="Add Visitor">
              <Fab variant="extended" size="small" color="primary" aria-label="add"
                    onClick={(e)=>navigate('/visitor/create')}
                  >
                  <AddIcon sx={{ mr: 1 }} />
                  Add Visitor
              </Fab>            
            </Tooltip>
        <Typography sx={{marginLeft:'auto', color:'primary.main'}} onClick={handleExpandClick }>Search&nbsp; </Typography>
        <IconButton size='large' 
          onClick={handleExpandClick }
        >
          {  expanded ? <ExpandLessIcon />:<ExpandMoreIcon />}
        </IconButton>


      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>


      <CardContent sx={{p:0,m:0, }}>

      
      <Grid  container  columns={18}  spacing={1}    sx={{p:1}}>
        
        
        <Grid item xs={18} sm={9}   md={4} lg={3}  sx={{ m:0 }}>
            <TextField 
                  size='small'
                  fullWidth  variant='outlined'
                  autoComplete='off'
                value={name}
                onChange={e=>setName(e.target.value)}
                id="id_name"
                aria-describedby="id_name_text"
                label='Name'

                InputProps={{
                  
                  endAdornment: (

                    <InputAdornment position="end">
                      <IconButton onClick={()=>setName('')}
                        //disabled={!Boolean(name)}
                        sx={{display:`${!Boolean(name) ?'none':'block'}`}} 
                        >
                        
                        <ClearIcon  size='small'/>
                        </IconButton>
                    </InputAdornment>
                  )
                }}
              />
        </Grid>
        <Grid item xs={18} sm={9}   md={4} lg={3}  sx={{  }}   >
          <TextField 
                  size='small'
                  fullWidth  variant='outlined'
                  autoComplete='off'
                value={email}
                onChange={e=>setEmail(e.target.value)}
                id="id_email"
                label='Email'

                InputProps={{
                  
                  endAdornment: (

                    <InputAdornment position="end">
                      <IconButton onClick={()=>setEmail('')} size='small' 
                        sx={{display:`${!Boolean(email) ?'none':'block'}`}} >
                        <ClearIcon  size='small'/>
                        </IconButton>
                    </InputAdornment>
                  )
                }}
              />
        </Grid>
        <Grid item xs={18} sm={9}   md={4} lg={3} sx={{  }}   >
          <TextField 
                  size='small'
                  fullWidth  
                  variant='outlined'
                value={phone}
                onChange={e=>setPhone(e.target.value)}
                id="id_phone"
                label='Phone Number'

                InputProps={{
                  
                  endAdornment: (

                    <InputAdornment position="end">
                      <IconButton onClick={()=>setPhone('')}
                        sx={{display:`${!Boolean(phone) ?'none':'block'}`}}                          >
                        <ClearIcon  size='small'/>
                        </IconButton>
                    </InputAdornment>
                  )
                }}
              />
        </Grid>
        <Grid item xs={18} sm={9}   md={4} lg={3}  sx={{ m:0,  }}   >
          <TextField 
                  size='small'
                  fullWidth  variant='outlined'
                value={company}
                onChange={e=>setCompany(e.target.value)}
                id="id_company"
                label='Organization'

                InputProps={{
                  
                  endAdornment: (

                    <InputAdornment position="end">
                      <IconButton onClick={()=>setCompany('')}
                        sx={{display:`${!Boolean(company) ?'none':'block'}`}}
                        >
                        <ClearIcon  size='small'/>
                        </IconButton>
                    </InputAdornment>
                  )
                }}
              />
        </Grid>
        
          <Grid item xs={18}  sm={9}   md={9} lg={6} sx={{ m:0 }} >
            <Box sx={{ display:'flex', flexDirection:'row', justifyContent: 'space-evenly' , m:0,p:0, 
                width:'100%'}}>
                <Button variant="outlined"size='small' color='primary' 
                          onClick={doSerachVisitor}
                          //sx={{textTransform:'none'}}
                      >
                    <SearchIcon sx={{display:{xs:'block', sm:'block'}}}/>
                    Search
                </Button>
              <Button variant="outlined"size='small' color='info' 
                          onClick={handleReset}
                          //sx={{textTransform:'none'}}
                         // disabled={![phone, email, name,company].some(Boolean)}
                          >
                  <ResetIcon sx={{display:{xs:'block', sm:'block'}}}/>
                  Clear
              </Button>
              {/* <Button variant="outlined"size='small' color='info' 
                          //sx={{textTransform:'none'}}
                          onClick={doRefresh}
                          //disabled={![phone, email, name,company].some(Boolean)}
                          >
                  <RefreshIcon />
                  Refresh
              </Button> */}
            </Box>
          </Grid>


      </Grid>
      </CardContent>
    </Collapse>
</Card>)


}




const VisitorListPage = () => {
    const {userInfo, isLoggedIn, tenantName,tenantLogo} = useAppAuthContext()
    const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
       setErrorMessage, errorTitle, setErrorTitle,
    }=usePlayContext()

    const {
      viewFilter, setViewFilter
    }=useViewContext()

    const navigate=useNavigate()
    const dispatch = useDispatch()

    const idss = useSelector(state=> selectVisitorByFilter(state, viewFilter))

    useEffect(() =>{
      setAppTitle( ['Visitors',])
      setErrorMessage('')
      setErrorTitle('')
      }, [])
  
    

  
    
   
  return (
    <Box sx={{ p:0, width:'100%' }}>
      
        <VisitorFilterPane/>
        
        
      <Paper sx={{border:'none', justifyContent: "flex-start", px: 1}} elevation={0} >
        
            <Stack sx={{ width: '100%' , mt:1}} spacing={1}>
            {
              idss.map(  (id, index)=><VisitorItem key={id} id={id} index={index} />)
            }
          </Stack>     


      </Paper>
      
      
    </Box>
  );
};

export default VisitorListPage;
